(function () {
  const APP_NOTIFY_SELECTORS = [
    "button[class*='notify']:not(.cuatro-notify-when-available)",
    "button[id*='notify']:not([id^='CuatroNotifyButton-'])",
    "a[class*='notify']",
    "a[id*='notify']",
    "button[class*='back-in-stock']",
    "button[id*='back-in-stock']",
    "a[class*='back-in-stock']",
    "a[id*='back-in-stock']",
    '.klaviyo-bis-trigger',
    '[data-klaviyo-notify-button]',
  ].join(',');

  function getProductInfoElements() {
    return document.querySelectorAll('product-info');
  }

  function getSectionId(productInfo) {
    return productInfo?.dataset?.section || null;
  }

  function getInfoContainer(productInfo) {
    return productInfo?.querySelector('.product__info-container') || null;
  }

  function getFloatingWrap(productInfo) {
    return productInfo?.querySelector('[id^="CuatroMobileFloatingAtc-"]') || null;
  }

  function getThemeNotifyButton(sectionId) {
    return document.getElementById(`CuatroNotifyButton-${sectionId}`);
  }

  function setThemeNotifyVisibility(themeButton, soldOut) {
    if (!themeButton) return;

    if (soldOut) {
      themeButton.hidden = false;
      themeButton.removeAttribute('hidden');
      themeButton.style.removeProperty('display');
      themeButton.setAttribute('aria-hidden', 'false');
      return;
    }

    themeButton.hidden = true;
    themeButton.setAttribute('hidden', '');
    themeButton.style.display = 'none';
    themeButton.setAttribute('aria-hidden', 'true');
  }

  function resolveSoldOutState(sectionId, variant) {
    const submitButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const submitEnabled =
      submitButton &&
      !submitButton.disabled &&
      submitButton.getAttribute('aria-disabled') !== 'true';

    if (submitEnabled) return false;
    if (variant && typeof variant.available === 'boolean') return !variant.available;
    if (submitButton) {
      return submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true';
    }
    return false;
  }

  function hideNotifyUi(productInfo, variant) {
    const sectionId = getSectionId(productInfo);
    const container = getInfoContainer(productInfo);
    if (!sectionId || !container) return;

    const soldOut = resolveSoldOutState(sectionId, variant);
    const floatingWrap = getFloatingWrap(productInfo);

    container.classList.toggle('product__info-container--variant-sold-out', soldOut);
    container.querySelectorAll('.product-block--buy-buttons .cuatro-notify-when-available').forEach((button) => {
      setThemeNotifyVisibility(button, soldOut);
    });
    setThemeNotifyVisibility(getThemeNotifyButton(sectionId), soldOut);

    if (!soldOut) {
      hideAppNotifyButtons(container, floatingWrap);
    }
  }

  function findAppNotifyButton(container, floatingWrap) {
    if (!container) return null;

    const matches = container.querySelectorAll(APP_NOTIFY_SELECTORS);
    for (let i = 0; i < matches.length; i++) {
      const node = matches[i];
      if (floatingWrap?.contains(node)) continue;
      if (node.classList?.contains('cuatro-notify-when-available')) continue;
      return node;
    }

    return null;
  }

  function hideAppNotifyButtons(container, floatingWrap) {
    if (!container) return;

    container.querySelectorAll(APP_NOTIFY_SELECTORS).forEach((node) => {
      if (floatingWrap?.contains(node)) return;
      node.hidden = true;
      node.setAttribute('aria-hidden', 'true');
      node.style.display = 'none';
      node.classList.add('cuatro-notify-hidden');
    });
  }

  function syncProductInfoState(productInfo, retriggerApp, variant) {
    const sectionId = getSectionId(productInfo);
    const container = getInfoContainer(productInfo);
    if (!sectionId || !container) return;

    const soldOut = resolveSoldOutState(sectionId, variant);

    if (retriggerApp && soldOut) {
      const variantInput = productInfo.querySelector('[name="id"]');
      if (variantInput) {
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        variantInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    hideNotifyUi(productInfo, variant);
    hideAppNotifyButtons(container, getFloatingWrap(productInfo));
  }

  const submitObserverState = new WeakMap();

  function bindSubmitButtonObserver(productInfo) {
    const sectionId = getSectionId(productInfo);
    if (!sectionId) return;

    const submitButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const previous = submitObserverState.get(productInfo);
    if (previous?.target === submitButton) return;

    previous?.observer?.disconnect();

    if (!submitButton) {
      submitObserverState.delete(productInfo);
      return;
    }

    const observer = new MutationObserver(() => syncProductInfoState(productInfo));
    observer.observe(submitButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
      childList: true,
      subtree: true,
    });
    submitObserverState.set(productInfo, { observer, target: submitButton });
  }

  function refreshProductInfoState(productInfo, variant) {
    initThemeNotifyButtons();
    bindSubmitButtonObserver(productInfo);
    syncProductInfoState(productInfo, false, variant);
  }

  function scheduleRefreshProductInfoState(productInfo, variant) {
    refreshProductInfoState(productInfo, variant);
    window.setTimeout(() => refreshProductInfoState(productInfo, variant), 0);
    window.setTimeout(() => refreshProductInfoState(productInfo, variant), 150);
    window.setTimeout(() => refreshProductInfoState(productInfo, variant), 500);
  }

  function triggerNotifyFlow(sectionId) {
    const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
    const container = getInfoContainer(productInfo);
    const floatingWrap = getFloatingWrap(productInfo);
    const appButton = findAppNotifyButton(container, floatingWrap);

    if (appButton) {
      appButton.click();
      return;
    }

    const variantInput = productInfo?.querySelector('[name="id"]');
    if (variantInput) {
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    window.setTimeout(() => {
      const retryButton = findAppNotifyButton(container, floatingWrap);
      if (retryButton) retryButton.click();
    }, 300);
  }

  function initThemeNotifyButtons() {
    document.querySelectorAll('.cuatro-notify-when-available').forEach((button) => {
      if (button.dataset.notifyBound === 'true') return;
      button.dataset.notifyBound = 'true';

      button.addEventListener('click', () => {
        const sectionId = button.id.replace('CuatroNotifyButton-', '');
        triggerNotifyFlow(sectionId);
      });
    });
  }

  function syncAllProductInfoStates() {
    getProductInfoElements().forEach((productInfo) => syncProductInfoState(productInfo));
  }

  function initNotifyMeSync() {
    initThemeNotifyButtons();
    syncAllProductInfoStates();

    getProductInfoElements().forEach((productInfo) => {
      const container = getInfoContainer(productInfo);
      if (!container) return;

      const observer = new MutationObserver(() => scheduleRefreshProductInfoState(productInfo));
      observer.observe(container, { childList: true, subtree: true });
    });

    getProductInfoElements().forEach((productInfo) => bindSubmitButtonObserver(productInfo));

    document.addEventListener('product-info:loaded', () => {
      getProductInfoElements().forEach((productInfo) => scheduleRefreshProductInfoState(productInfo));
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
        const target = event?.data?.event?.target;
        if (!target) return;

        getProductInfoElements().forEach((productInfo) => {
          if (!productInfo.contains(target)) return;
          hideNotifyUi(productInfo, { available: true });
        });
      });

      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = event?.data?.sectionId;
        const variant = event?.data?.variant;

        if (!sectionId) {
          syncAllProductInfoStates();
          return;
        }

        const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
        if (!productInfo) return;

        const sync = (retriggerApp) => syncProductInfoState(productInfo, retriggerApp, variant);

        sync(false);
        window.requestAnimationFrame(() => sync(!variant?.available));
        window.setTimeout(() => sync(false), 0);
        window.setTimeout(() => sync(false), 250);
        window.setTimeout(() => sync(false), 750);
        window.setTimeout(() => sync(false), 1500);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNotifyMeSync);
  } else {
    initNotifyMeSync();
  }
})();
